import React, { useContext } from 'react';
import { EditGameContext, IEditGameContext } from 'modules/Entertainment/Games/EditGame/editGameState/editGameContext';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import style from './DownloadBtn.module.scss';

const DownloadBtn: React.FC = () => {
	const { gameFilePath } = useContext<IEditGameContext>(EditGameContext);

	return (
		<div className={style.container}>
			<BlobDownloader
				filePath={gameFilePath}
				fileExtension="apk"
				fileName="game"
				label="downloadGameFileButton"
			/>
		</div>
	);
};

export default DownloadBtn;
